import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import costCategoriesApi from '@/features/dashboard/costCategories/api/costCategoriesApi.ts';
import { costCategoriesApiQueryKeys } from '@/features/dashboard/costCategories/api/costCategoriesApi.queryKeys.ts';
import { CostCategoryDto } from '@/features/dashboard/costCategories/types/CostCategoryDto.ts';
import { invalidateFinanceRelatedQueries } from '@/utils/invalidateFinanceQueries.ts';
import { getCostCategoryMergeMessage } from '@/features/dashboard/costCategories/api/costCategoryErrors.ts';

interface MergeParams {
  id: string;
  targetId: string;
}

export default function useMergeCostCategory() {
  const queryClient = useQueryClient();

  return useMutation<CostCategoryDto, Error, MergeParams>({
    mutationFn: ({ id, targetId }) => costCategoriesApi.mergeInto(id, targetId),
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({
        queryKey: costCategoriesApiQueryKeys.all(),
        // Wiersz scalonej kategorii wisi jeszcze na ekranie, dopóki nie wróci
        // lista, więc jej zapytanie o użycie odświeżyłoby się na 404.
        predicate: (query) => query.queryKey[1] !== id,
      });
      // Wydatki i rozbicie budżetu pokazują nazwę kategorii, więc też się zmieniają.
      invalidateFinanceRelatedQueries(queryClient);
      toast.success('Kategorie zostały scalone');
    },
    onError: (error: Error) => {
      // Ten sam komunikat, co pod polem w modalu — surowy tekst backendu
      // brzmiał inaczej niż to, co użytkownik czyta dwa centymetry obok.
      toast.error('Nie udało się scalić kategorii', {
        description: getCostCategoryMergeMessage(error) ?? error.message,
      });
    },
  });
}
